import { Check } from "lucide-react";

const STAGES = [
  { key: "requested", label: "Requested" },
  { key: "quoted", label: "Quoted" },
  { key: "booked", label: "Booked" },
  { key: "in_progress", label: "In Progress" },
  { key: "completed", label: "Completed" },
];

export default function StatusTracker({ status }) {
  const idx = STAGES.findIndex((s) => s.key === status);
  return (
    <div data-testid="status-tracker" className="flex items-center w-full">
      {STAGES.map((s, i) => {
        const done = i < idx;
        const active = i === idx;
        return (
          <div key={s.key} className="flex items-center flex-1 last:flex-none">
            <div className="flex flex-col items-center">
              <div className={`h-8 w-8 rounded-full flex items-center justify-center text-xs font-bold border-2 transition-colors
                ${done ? "bg-emerald-500 border-emerald-500 text-white"
                  : active ? "bg-amber-500 border-amber-500 text-white"
                  : "bg-white border-slate-300 text-slate-400"}`}>
                {done ? <Check size={14} /> : i + 1}
              </div>
              <span className={`mt-1.5 text-[11px] font-medium whitespace-nowrap ${active ? "text-amber-700" : done ? "text-emerald-600" : "text-slate-400"}`}>
                {s.label}
              </span>
            </div>
            {i < STAGES.length - 1 && (
              <div className={`h-0.5 flex-1 mx-1 -mt-5 ${i < idx ? "bg-emerald-500" : "bg-slate-200"}`} />
            )}
          </div>
        );
      })}
    </div>
  );
}

export const StatusPill = ({ status }) => {
  const map = {
    requested: "bg-slate-100 text-slate-700",
    quoted: "bg-indigo-100 text-indigo-800",
    booked: "bg-purple-100 text-purple-800",
    in_progress: "bg-amber-100 text-amber-900",
    completed: "bg-emerald-100 text-emerald-800",
    cancelled: "bg-red-100 text-red-700",
  };
  return (
    <span className={`text-xs font-semibold px-2.5 py-1 rounded-full capitalize ${map[status] || "bg-slate-100"}`}>
      {(status || "").replace("_", " ")}
    </span>
  );
};
